import styled from 'styled-components';
import { rem, em } from 'polished';
import { Heading } from 'elements';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const Header = styled.header`
    h1 {
        font-size: ${rem(21)};
    }
     ${media.tabletSmall`
      
    `};
`;

export const StyledHeading = styled(Heading)`
  margin-bottom: 0 !important;

  ${media.tabletSmall`
    font-size: ${rem(18)};
  `};
`;

export const StyledContent = styled.article`
 
  margin-top: ${rem(40)} !important;
  margin-bottom: ${rem(28)} !important;
   p {
     font-size: ${rem(22)};
     line-height: ${rem(30)};
     margin:0;
     padding:0;
    
  }
  ${media.tabletSmall`
        margin-top: ${rem(20)} !important;
        margin-bottom: ${rem(14)} !important;
      p {
        font-size: ${rem(14)};
        line-height: ${rem(20)};
      }
    `};

`;



// WEBPACK FOOTER //
// ./src/pages/Deputati/styled.js